import React from 'react'
import "../About.css"

import collageImage from "../../../Asset/About/about-desktop-collage-image.png"
import collageImageMobile from "../../../Asset/About/about-mobile-collage-image.png"
const TopContent = () => {
  return (
    <div className='pt-44 w-full'>

      <div id="heading" className='mb-5 md:mb-10'>
        <h1 className='text-[var(--dark-blue)] text-[2.5rem] md:text-6xl lg:text-7xl  font-ClashGrotesk font-medium text-center'>What is Net Gala?</h1>
      </div>

      {/* For mobile devices only look here */}
      <div className='flex flex-col justify-center items-center md:hidden'>
        <div className='w-[93%]'>
          <img src={collageImageMobile} alt="" />
        </div>
      </div>


      {/* For desktop and medium devices look here */}
      <div className='w-full md:p-6 md:flex md:flex-row justify-center hidden '>
        <img src={collageImage} alt="" />
      </div>

    </div>
  )
}

export default TopContent
